import React from "react";
import Header from "../components/Header";
import Hero from "../components/Hero";
import About from "../components/About";
import News from "../components/News";
import PhotoCarousel from "../components/PhotoCarousel";
import Donate from "../components/Donate";
import Contact from "../components/Contact";
import Footer from "../components/Footer";

const HomePage = () => {
  return (
    <div className="min-h-screen bg-white">
      <Header />
      <main>
        <Hero />
        <About />
        <News />
        <PhotoCarousel />
        <Donate />
        <Contact />
      </main>
      <Footer />
    </div>
  );
};

export default HomePage;
